import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { COLORS } from '@helpers/constants'
import { SetItalic, SetBold, TextStyle, SetUppercase, Padding } from './style'

const Text = (props) => {
    const {
        italic,
        bold,
        size,
        children,
        uppercase,
        color = COLORS.BLACK.TEXT,
        align,
        noPadding = false,
        extraClasses,
    } = props

    const className = classNames(TextStyle, color, size, align, {
        [`${Padding}`]: !noPadding,
        [`${SetBold}`]: bold,
        [`${SetItalic}`]: italic,
        [`${SetUppercase}`]: uppercase,
    }, extraClasses)

    return (
        <p className={className} color={color}>
            {children}
        </p>
    )
}

Text.propTypes = {
    italic: PropTypes.bool,
    bold: PropTypes.bool,
    uppercase: PropTypes.bool,
    size: PropTypes.string,
    children: PropTypes.any,
    color: PropTypes.any,
    align: PropTypes.string,
    noPadding: PropTypes.bool,
    extraClasses: PropTypes.string,
}

export default Text
